import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";
import { useAuth } from "../AuthContext";
import { useI18n } from "../I18nContext";

export default function MeetingCopilot() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const [agent, setAgent] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/toolkit/agents/meeting-copilot?lang=${lang}`)
      .then((r) => setAgent(r.data))
      .catch((e) => setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message));
    if (user?.role === "entrepreneur" || user?.role === "advisor" || user?.role === "admin") {
      api.get("/meeting-templates").then((r) => setTemplates(r.data || [])).catch(() => setTemplates([]));
    }
  }, [lang, user?.role]);

  if (!agent && !err) return <div className="tb-loading">{t("common.loading")}</div>;

  const isPrincipal = user?.role === "entrepreneur" && !user?.team_owner_id;

  return (
    <div className="tb-page" data-testid="meeting-copilot">
      <Link to="/app/toolbox" className="tb-muted" style={{ fontSize: "0.85rem" }}>← {t("comingSoon.backToToolbox")}</Link>
      <h1 className="tb-h1" style={{ marginTop: 8 }}>{agent?.name || t("agents.meetingCopilot")}</h1>
      <p className="tb-muted" style={{ maxWidth: 760 }}>{agent?.tagline}</p>
      {err && <div className="tb-form-error">{err}</div>}
      <div className="tb-block" style={{ marginTop: 20 }}>
        <p style={{ whiteSpace: "pre-wrap" }}>{agent?.summary}</p>
        <ul>
          <li>{t("agents.useBefore")}</li>
          <li>{t("agents.useDuring")}</li>
          <li>{t("agents.useAfter")}</li>
          <li>{t("agents.useSummary")}</li>
        </ul>
      </div>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 16 }}>
        {user?.role === "entrepreneur" && (
          <Link to="/app/team-1-1/new" className="tb-primary-btn" style={{ textDecoration: "none" }} data-testid="copilot-book">
            {t("team1v1.bookButton")}
          </Link>
        )}
        {isPrincipal || user?.role === "advisor" || user?.role === "admin" ? (
          <Link to="/app/settings/templates" className="tb-ghost-btn" style={{ textDecoration: "none" }} data-testid="copilot-templates">
            {t("team1v1.manageTemplates")}
          </Link>
        ) : null}
      </div>

      {templates.length > 0 && (
        <div className="tb-block" style={{ marginTop: 24 }} data-testid="copilot-templates-list">
          <h3 style={{ marginTop: 0 }}>{t("agents.yourTemplates")}</h3>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {templates.map((tpl) => (
              <li key={tpl.id} style={{ padding: "10px 0", borderBottom: "1px solid var(--border)" }}>
                <strong>{tpl.name}</strong>
                <div className="tb-muted" style={{ fontSize: "0.82rem" }}>
                  {(tpl.before_questions || tpl.questions || []).length} {t("settings.templates.beforeCount")}
                  {" · "}
                  {(tpl.after_questions || []).length} {t("settings.templates.afterCount")}
                  {tpl.summary_direction_md ? ` · ${t("agents.hasSummaryDir")}` : ""}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
